<template>
    <!-- 储值消费报表管理－页面 -->
    <content-view>
        <template slot="header">
            <a-tabs defaultActiveKey="1" :animated="false" @change="tabsChange">
                <a-tab-pane tab="支付记录" key="1">
                    <a-form :form="payConsumForm" layout="inline">
                        <a-form-item label="会员手机号" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-input v-decorator="['account']" placeholder="请输入"></a-input>
                        </a-form-item>
                        <a-form-item label="消费时间" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-range-picker :allowClear="false" v-decorator="['date', {initialValue: [$moment($moment().format('YYYY/MM/DD 00:00:00')),$moment($moment().format('YYYY/MM/DD 23:59:59'))]}]" showTime format="YYYY/MM/DD HH:mm" style="width: 100%;" />
                        </a-form-item>
                        <a-form-item label="支付方式" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select allowClear placeholder="请选择" v-decorator="['payMode']" >
                                <template v-for="(item,index) in $utils.payMode">
                                    <a-select-option :key="index" :value="index" v-if="index > 0">{{item}}</a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="订单编号" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-input v-decorator="['id']" placeholder="请输入"></a-input>
                        </a-form-item>
                        <a-form-item label="消费类型" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select allowClear :options="orderTypeOptions" v-decorator="['orderType']" placeholder="请选择" />
                        </a-form-item>
                        <a-form-item label="消费门店" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select allowClear :options="shopList" v-decorator="['shopId']" placeholder="请选择" />
                        </a-form-item>
                        <a-form-item label="退款情况" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select allowClear :options="refundList" v-decorator="['refundState']" placeholder="请选择" />
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button type="primary" @click="payRecordSearch(true)">搜 索</a-button>
                            <a-button @click="formReset('payConsumForm')">重 置</a-button>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
                <a-tab-pane tab="退款记录" key="2">
                    <a-form :form="refundConsumForm" layout="inline">
                        <a-form-item label="会员手机号" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-input v-decorator="['account']" placeholder="请输入"></a-input>
                        </a-form-item>
                        <a-form-item label="消费时间" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-range-picker :allowClear="false" v-decorator="['date', {initialValue: [$moment($moment().format('YYYY/MM/DD 00:00')),$moment($moment().format('YYYY/MM/DD 23:59'))]}]" showTime format="YYYY/MM/DD HH:mm" style="width: 100%;" />
                        </a-form-item>
                        <a-form-item label="原订单号" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-input v-decorator="['orderId']" placeholder="请输入"></a-input>
                        </a-form-item>
                        <a-form-item label="订单编号" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-input v-decorator="['id']" placeholder="请输入"></a-input>
                        </a-form-item>
                        <a-form-item label="消费类型" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select :options="orderTypeOptions" v-decorator="['orderType']" placeholder="请选择" />
                        </a-form-item>
                        <a-form-item label="消费门店" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select :options="shopList" v-decorator="['shopId']" placeholder="请选择" />
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button type="primary" @click="refundRecordSearch(true)">搜 索</a-button>
                            <a-button @click="formReset('refundConsumForm')">重 置</a-button>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
            </a-tabs>
        </template>
        <div v-show="currentKey === '1'">
            <a-card :bordered="false">
                <a-alert slot="title" type="warning" showIcon>
                    <template slot="message">
                        实际总收入：
                        <span class="font-bold">{{payTable.payAmountSum}}元</span>
                        <span class="ml16 mr16">|</span>
                        <span class="font-bold">{{payTable.payCount}}笔</span>
                    </template>
                </a-alert>
                <a-button class="ml80" slot="extra" :loading="exportLoading" @click="exportPayConsum" v-if="getBtnByAuth('storedConsumExport')">导出</a-button>
                <a-table bordered :loading="payTable.loading" style="word-break:break-all;" :dataSource="payTable.dataSource" :columns="payTable.columns" :pagination="payTable.pagination" @change="payTableChangePage" :rowKey="(record,index) => index">
                    <div slot="expandedRowRender" slot-scope="row" v-if="getBtnByAuth('storedConsumDetail')">
                        <a-table size="small" :dataSource="row.userOrderDetailVoList" :columns="payTable.detailColumns" :pagination="false" :rowKey="(record,index) => index"></a-table>
                    </div>
                    <template slot="emptyStr" slot-scope="text">
                        {{text | emptyStr}}
                    </template>
                    <template slot="payMode" slot-scope="text">
                        {{$utils.payMode[text]}}
                    </template>
                    <template slot="orderTypeStr" slot-scope="text">
                        {{text | orderTypeStr}}
                    </template>
                    <template slot="refundState" slot-scope="text">
                        {{text | refundState}}
                    </template>
                    <template slot="state">
                        <!-- {{text | orderState}} -->
                        已支付
                    </template>
                </a-table>
            </a-card>
        </div>
        <div v-show="currentKey === '2'">
            <a-card :bordered="false">
                <a-alert slot="title" type="warning" showIcon>
                    <template slot="message">
                        实际退款总额：
                        <span class="font-bold">{{refundTable.payAmountSum}}元</span>
                        <span class="ml16 mr16">|</span>
                        <span class="font-bold">{{refundTable.payCount}}笔</span>
                    </template>
                </a-alert>
                <a-button class="ml80" slot="extra" :loading="exportLoading" @click="exportRefundConsum" v-if="getBtnByAuth('storedConsumExport')">导出</a-button>
                <a-table bordered :loading="refundTable.loading" style="word-break:break-all;" :dataSource="refundTable.dataSource" :columns="refundTable.columns" :pagination="refundTable.pagination" @change="refundTableChangePage" :rowKey="(record,index) => index">
                    <div slot="expandedRowRender" slot-scope="row" v-if="getBtnByAuth('storedConsumDetail')" >
                        <a-table size="small" :dataSource="row.userOrderDetailVoList" :columns="refundTable.detailColumns" :pagination="false" :rowKey="(record,index) => index"></a-table>
                    </div>
                    <template slot="emptyStr" slot-scope="text">
                        {{text | emptyStr}}
                    </template>
                    <template slot="payMode" slot-scope="text">
                        {{$utils.payMode[text]}}
                    </template>
                    <template slot="orderTypeStr" slot-scope="text">
                        {{text | orderTypeStr}}
                    </template>
                    <template slot="state" slot-scope="text">
                        {{text | orderState}}
                    </template>
                </a-table>
            </a-card>
        </div>
    </content-view>
</template>
<script>
const payModeOptions = [
    {value: 1, label: '支付宝'},
    {value: 2, label: '微信'},
    {value: 3, label: 'POS机'},
    {value: 4, label: '现金'},
    {value: 5, label: '第三方购买'},
    {value: 6, label: '储值'},
    {value: 7, label: '旺POS'}
]
const orderTypeOptions = [
    {value: 1, label: '票券'},
    {value: 2, label: '课程'},
    {value: 3, label: '零售'},
    {value: 4, label: '餐品'},
    {value: 5, label: '综合'},
    {value: 6, label: '储值'}
]
const refundList = [
    {value: 1, label: '未退款'},
    {value: 2, label: '部分退款'},
    {value: 3, label: '全部退款'},
]
const payTableColumns = [
    {
        title: '支付订单号',
        dataIndex: 'id'
    },
    {
        title: '会员手机号',
        dataIndex: 'account'
    },
    {
        title: '交易时间',
        dataIndex: 'payTime'
    },
    {
        title: '支付方式',
        dataIndex: 'payMode',
        scopedSlots: { customRender: "payMode"}
    },
    {
        title: '实际收入金额/元',
        dataIndex: 'payAmount'
    },
    {
        title: '原支付金额/元',
        dataIndex: 'orderAmount'
    },
    {
        title: '储值余额/元',
        dataIndex: 'storedValue',
        scopedSlots: { customRender: "emptyStr" }
    },
    {
        title: '消费类型',
        dataIndex: 'orderType',
        scopedSlots: { customRender: "orderTypeStr"}
    },
    {
        title: '消费门店',
        dataIndex: 'shopName',
        scopedSlots: { customRender: "emptyStr" }
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: "state" }
    },
    {
        title: '退款情况',
        dataIndex: 'refundState',
        scopedSlots: { customRender: "refundState" }
    },
];
const refundTableColumns = [
    {
        title: '退款订单号',
        dataIndex: 'id'
    },
    {
        title: '原订单号',
        dataIndex: 'orderId'
    },
    {
        title: '会员手机号',
        dataIndex: 'account'
    },
    {
        title: '交易时间',
        dataIndex: 'applyTime'
    },
    {
        title: '退款金额/元',
        dataIndex: 'amount'
    },
    {
        title: '原订单实际支付金额/元',
        dataIndex: 'orderAmount'
    },
    {
        title: '储值余额/元',
        dataIndex: 'storedValue',
        scopedSlots: { customRender: "emptyStr" }
    },
    {
        title: '消费类型',
        dataIndex: 'orderType',
        scopedSlots: { customRender: "orderTypeStr"}
    },
    {
        title: '消费门店',
        dataIndex: 'shopName',
        scopedSlots: { customRender: "emptyStr" }
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: "state" }
    }
];
const payTableColumnsDetail = [
    {
        title: '商品名称',
        dataIndex: 'goodsName'
    },
    {
        title: '商品单价/元',
        dataIndex: 'price'
    },
    {
        title: '购买数量',
        dataIndex: 'count'
    },
    {
        title: '合计/元',
        dataIndex: 'priceSum'
    }
];
export default {
    name: "storedConsumRepord",
    components: {},
    props: {},
    data() {
        return {
            isInitial: true,
            payModeOptions,
            orderTypeOptions,
            refundList,
            payTable: {
                loading: false,
                payAmountSum: 0,
                payCount: 0,
                columns: payTableColumns,
                detailColumns: payTableColumnsDetail,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                dataSource: [],
            },
            refundTable: {
                loading: false,
                payAmountSum: 0,
                payCount: 0,
                columns: refundTableColumns,
                detailColumns: payTableColumnsDetail,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                dataSource: [],
            },
            shopList: [],
            exportLoading: false,
            currentKey: '1'
        };
    },
    computed: {},
    filters: {
        emptyStr(val) {
            return (!Boolean(val) && val !== 0) ? "-" : val;
        },
        payModeStr(val) {
            return val === 1 ? '支付宝' : val === 2 ? '微信' : val === 3 ? 'POS机' : val === 4 ? '现金' : val === 5 ? '第三方购买' : val === 6 ? '储值' : val === 7 ? '旺POS' : "-";
        },
        orderTypeStr(val) {
            return val === 1 ? '票券' : val === 2 ? '课程' : val === 3 ? '零售' : val === 4 ? '餐品' : val === 5 ? '综合' : val === 6 ? '储值' : "-";
        },
        orderState(val) {
            return val === 0 ? '审批中' : val === 1 ? '退款中' : val === 2 ? '退款成功' : val === 3 ? '退款失败' : val === 4 ? '无需退款' : "-";
        },
        refundState(val) {
            return val === 1 ? '未退款' : val === 2 ? '部分退款' : val === 3 ? '全部退款'  : "-";
        }
    },
    methods: {
        formReset(formName) {
            this[formName].resetFields();
            if (formName === 'payConsumForm') {
                this.payTable.current = 1;
                this.payRecordSearch();
            } else {
                this.refundTable.current = 1;
                this.refundRecordSearch();
            }
        },
        tabsChange(activeKey) {
            this.currentKey = activeKey;
            if (this.isInitial) {
                this.isInitial = false;
                this.$nextTick(() => {
                    if (activeKey === '2') {
                        this.refundRecordSearch();
                    }
                });
            }
        },
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res.map(item => {return {value: item.id, label: item.name}});
                this.shopList.unshift({value: -1, label: '总平台'})
            });
        },
        payTableChangePage(pagination) {
            this.payTable.pagination = pagination;
            this.payRecordSearch();
        },
        refundTableChangePage(pagination) {
            this.refundTable.pagination = pagination;
            this.refundRecordSearch();
        },
        /**
         * @payRecordSearch 储值支付表数据拉取
         */
        payRecordSearch(isButton) {
            if (Boolean(isButton)) {
                this.payTable.pagination.current = 1;
            }
            this.payConsumForm.validateFields((errors,values) => {
                if (err) return;
                values.rechargeStartTime = values.date[0].format('YYYY-MM-DD HH:mm:00');
                values.rechargeEndTime = values.date[1].format('YYYY-MM-DD HH:mm:59');
                delete values.date;
                this.payRecordSearchSum(values);
                this.payTable.loading = true;
                this.$api.statement.payRecordSearch({
                    body: {
                        ...values,
                        pageNum: this.payTable.pagination.current,
                        pageSize: this.payTable.pagination.pageSize,
                    }
                }).then(res => {
                    this.payTable.loading = false;
                    this.payTable.dataSource = res.data;
                    this.payTable.pagination.total = res.total;
                }).catch(err => {
                    this.payTable.loading = false;

                })
            });
        },
        /**
         * @refundRecordSearch 储值退款表数据拉取
         */
        refundRecordSearch(isButton) {
            if (Boolean(isButton)) {
                this.refundTable.pagination.current = 1;
            }
            this.refundConsumForm.validateFields((errors,values) => {
                if (err) return;
                values.startTime = values.date[0].format('YYYY-MM-DD HH:mm:00');
                values.endTime = values.date[1].format('YYYY-MM-DD HH:mm:59');
                delete values.date;
                this.refundRecordSearchSum(values);
                this.refundTable.loading = true;
                this.$api.statement.refundRecordSearch({
                    body: {
                        ...values,
                        pageNum: this.refundTable.pagination.current,
                        pageSize: this.refundTable.pagination.pageSize,
                    }
                }).then(res => {
                    this.refundTable.loading = false;
                    this.refundTable.dataSource = res.data;
                    this.refundTable.pagination.total = res.total;
                }).catch(err => {
                    this.payTable.loading = false;

                })
            });
        },
        /**
         * @exportXlsx 导出excel
         */
        exportXlsx(data,fileName) {
            let a = document.createElement("a");
            let blob = new Blob([data], {
                type: "application/vnd.ms-excel"
            });
            let downloadUrl = window.URL.createObjectURL(blob);
            let name = fileName + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'
            a.setAttribute("href", downloadUrl);
            var reportName = decodeURI(name);
            a.setAttribute("download", reportName);
            a.click();
        },
        /**
         * @exportPayConsum 支付记录导出
         */
        exportPayConsum() {
            this.payConsumForm.validateFields((err,values) => {
                if (err) return;
                values.rechargeStartTime = values.date[0].format('YYYY-MM-DD HH:mm:00');
                values.rechargeEndTime = values.date[1].format('YYYY-MM-DD HH:mm:00');
                delete values.date;
                if(!err) {
                    this.exportLoading = true;
                    this.$api.statement.exportPayRecord(
                        {
                            body: {
                                ...values,
                                pageNum: 1,
                                pageSize: 999999
                            }
                        },
                        {
                            responseType: "blob"
                        })
                    .then(res => {
                        this.exportLoading = false;
                        this.exportXlsx(res.data,'储值消费支付记录报表');
                    }).catch(err => {
                        this.exportLoading = false;
                    })
                }
            })
        },
        /**
         * @exportRefundConsum 退款记录导出
         */
        exportRefundConsum() {
            this.refundConsumForm.validateFields((err,values) => {
                if (err) return;
                values.startTime = values.date[0].format('YYYY-MM-DD HH:mm:00');
                values.endTime = values.date[1].format('YYYY-MM-DD HH:mm:00');
                delete values.date;
                if(!err) {
                    this.exportLoading = true;
                    this.$api.statement.exportRefundRecord(
                        {
                            body: {
                                ...values,
                                pageNum: 1,
                                pageSize: 999999
                            }
                        },
                        {
                            responseType: "blob"
                        })
                    .then(res => {
                        this.exportLoading = false;
                        this.exportXlsx(res.data,'储值消费退款记录报表');
                    }).catch(err => {
                        this.exportLoading = false;
                    })
                }
            })
        },
        /**
         * @payRecordSearchSum 支付记录列表和条数
         */
        payRecordSearchSum(reqData) {
            this.$api.statement.payRecordSearchSum({
                body: reqData
            }).then(res => {
                if (res.payCount > 0) {
                    this.payTable.payAmountSum = res.payAmountSum;
                    this.payTable.payCount = res.payCount;
                } else {
                    this.payTable.payAmountSum = 0;
                    this.payTable.payCount = 0;
                }
            });
        },
        /**
         * @payRecordSearchSum 退款记录列表和条数
         */
        refundRecordSearchSum(reqData) {
            this.$api.statement.refundRecordSearchSum({
                body: reqData
            }).then(res => {
                if (res.payCount > 0) {
                    this.refundTable.payAmountSum = res.payAmountSum;
                    this.refundTable.payCount = res.payCount;
                } else {
                    this.refundTable.payAmountSum = 0;
                    this.refundTable.payCount = 0;
                }
            });
        }
    },
    beforeCreate() {
        this.payConsumForm = this.$form.createForm(this);
        this.refundConsumForm = this.$form.createForm(this);
    },
    created() {
    },
    mounted() {
        this.getShopList();
        this.payRecordSearch();
    }
};
</script>
<style lang="scss">
</style>